if(typeof BSS_B2B != undefined) {
  //v3 change variant
  if(window.location.pathname.includes("/products")) {
      setTimeout(() =>{
        const variantSelection = document.querySelector("variant-selection");
        if (variantSelection) {
          const mutationObserver = new MutationObserver((recordList, observe) => {
              setTimeout(() =>{
                const productForm = document.querySelector("[bss-b2b-main-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
              }, 500) 
          });
          mutationObserver.observe(variantSelection, { attributes: true });
        }
      }, 1000)
    }
  
    setTimeout(() =>{
      let quickViewBtn = document.querySelectorAll('.quickshop-button');
      if (quickViewBtn.length) {
          for (let i = 0; i < quickViewBtn.length; i++) {
              quickViewBtn[i].onclick = function () {
                  setTimeout(function () {
                    document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"))    
                  }, 1500);
              }
          }
      }
    }, 3000)
}
